import { render, staticRenderFns } from "./SurveyModal.vue?vue&type=template&id=0cffdbd4&scoped=true"
import script from "./SurveyModal.vue?vue&type=script&lang=ts"
export * from "./SurveyModal.vue?vue&type=script&lang=ts"
import style0 from "./SurveyModal.vue?vue&type=style&index=0&id=0cffdbd4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cffdbd4",
  null
  
)

export default component.exports